import { Controller } from 'stimulus';

class Anniversary extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    // eslint-disable-next-line no-restricted-globals
    addEventListener('change', (event) => {
      const { value, name } = event.target;
      const element = document.getElementById('partner-fields');

      if (name !== 'availability_partner') {
        return;
      }

      if (value === 'present') {
        element.style.display = 'block';
      }

      if (value === 'absent') {
        element.style.display = 'none';
      }
    });
  }
}

Anniversary.targets = [
  //
];

export default Anniversary;
